/// <reference path="./index.d.ts" />
import * as React from 'react';
import classnames from 'classnames';
import loadable from '../../common/loadable';
import { Button, Tab, Dialog } from '@alifd/next';
import { getText } from '../../utils/i18n';
// 为何不用next的slider，它的slider为了动效封装了很多层元素和逻辑，对第三方插件不友好，比如放大镜受限于样式层级就无法使用
import Slider from './slider';
import safeLog from '@alife/bc-safe-log';
import Video from './media/video';
import Image from './media/image';
import VR from './media/vr';
import Customize from './media/custom';
import eventManager from '@alife/scc-event-manager/event-manager';
import Empty from './empty';

import './index.scss';

const AsyncCompareAndShare = loadable(() => import('../compare-and-share'), {
  loadingVisible: false,
});
// const AsyncDialog = loadable(() => import('@alifd/next/lib/dialog'));

const TabPane = Tab.Item;
let dialogOpenTime = null;
const PRODUCT_TAB_INDEX = 0;

function Inner({ children, ...others }) {
  // 注意这里要透传其他属性到到下层节点上，Slider 底层需要执行元素的 clone 操作
  return <div {...others}>{children}</div>;
}

function getMediaComponent(mediaType: PcMainImage.MediaType) {
  switch (mediaType) {
    case 'image':
      return Image;
    case 'video':
      return Video;
    case 'lightCustomModel':
      return Customize;
    case 'customModel':
      return Customize;
    case 'customHome':
      return VR;
    default:
      return;
  }
}

export default class MainImage extends React.Component<
  {
    mediaItems: PcMainImage.MediaItems;
    productId: number;
    i18n: PcMainImage.II18n;
    // compare and share的入参
    productIsPersonal: boolean;
    subject: string;
    companyId: number;
    productIsMarketGoods: boolean;
    language: string;
  },
  {
    mediaItemsOfState: PcMainImage.MediaItems;
    visible: boolean;
    mainMediaIndex: number;
    dialogMediaIndex: number;
    dialogTabIndex: number;
    mainImageList: PcMainImage.MediaItemsInDialogTab;
    tabs: PcMainImage.MediaItemsInDialogTab;
    dialogHeight: string;
    isEmpty: boolean;
  }
> {
  static defaultProps = {
    mediaItems: [],
  };

  dialogEle: HTMLElement;
  constructor(props) {
    super(props);

    const { mediaItems } = props;

    
    
    const tabs = this.generateTabs(this.dialogMediaFilter(mediaItems));
    const mainImageList = this.generateTabs(mediaItems);

    this.state = {
      visible: false,
      mainMediaIndex: 0,
      dialogMediaIndex: 0,
      dialogTabIndex: 0,
      mainImageList,
      tabs,
      dialogHeight: '',
      mediaItemsOfState: mediaItems,
      isEmpty: mediaItems.length === 0,
    };
  }

  componentDidMount() {
    const { i18n } = this.props;
    const { mediaItemsOfState, isEmpty } = this.state;
    if (isEmpty) return;

    this.fetchAttachMediaItems();
    // 增加曝光
    if (mediaItemsOfState && mediaItemsOfState.length > 0) {
      if (mediaItemsOfState[0].type.indexOf('Model') > 0) {
        safeLog(
          '/sc.details.commonLogs',
          'EXP',
          `info=${mediaItemsOfState[0].type}`,
        );
      }
    }
    // 放置收藏布点
    try {
      const eleSelector = '#detail-favorite-mark';
      const ele = document.querySelector(eleSelector);
      ele.addEventListener('click', () => {
        safeLog('/sc.details.addFav', 'CLK');
      });
      // 多语言文案
      window.SCHD_COMS = window.SCHD_COMS || {};
      window.SCHD_COMS.__favoriteMI18nData = {
        favText: i18n['favoriteM_favText'],
        favSupplierText: i18n['favoriteM_favSupplierText'],
        'considering-tips': (i18n['favoriteM_considering_tips'] || '')
          .replace('{0}', '')
          .replace('{1}', ''),
        titleOnAppStore: i18n['favoriteM_titleOnAppStore'],
        titleOnAndroid: i18n['favoriteM_titleOnAndroid'],
        maxFavCountTips: i18n['favoriteM_maxFavCountTips'],
        signIn: i18n['favoriteM_signIn'],
      };
      window.SCHD_COMS.use(['favorite'], () => {
        const favoriteObj = new (window.SCHD_COMS as any).FavoriteManager();
        favoriteObj.render({ element: eleSelector, onlyIcon: true });
      });
    } catch (e) {
      console.error(e);
    }
    this.listenCertificationClick();
    this.listenSkuImageClick();
    safeLog('/sc.details.commonLogs', 'CLK', 'info=&action=mainImageExpose');

    // 调用大促渲染
    if (window.__PROMOTION_BOOTSTRAP__) {
      window.__PROMOTION_BOOTSTRAP__('detail-corner-mark');
    }

    this.doExpose();
  }

  fetchAttachMediaItems() {
    const { productId, language } = this.props;
    fetch(
      `/event/app/detailBoothImage/median.htm?detailId=${productId}&language=${language ||
        ''}`,
    )
      .then(res => res.json())
      .then(res => {
        if (res && res.data) {
          const newMediaItems = this.state.mediaItemsOfState.concat(res.data);
          const tabs = this.generateTabs(this.dialogMediaFilter(newMediaItems));
          const mainImageList = this.generateTabs(newMediaItems);
          this.setState({
            mediaItemsOfState: newMediaItems,
            tabs,
            mainImageList,
          });
        }
      });
  }

  listenCertificationClick() {
    eventManager.on('ON_DETAIL_CERTIFICATION_CLICK', ({certType, certIndex}) => {
      const {tabs} = this.state;
      window.goldlog && window.goldlog.record('/sc.6.pc.detail.certificate','EXP','type=dialog','GET')
      // 聚焦证书
      let indexId = tabs.length - 1
      if (certType === 'INSPECTION_REPORT') {
        tabs.forEach((item, index) => {
          if (item.media.filter((i:any) => i.sellingPoint).length > 0) {
            indexId = index;
          }
        })
      }
      
      this.setState({
        ...this.state,
        dialogTabIndex: indexId,
        dialogMediaIndex: certIndex,
        visible: true,
      });
    })
  }

  listenSkuImageClick = () => {
    eventManager.on('ON_DETAIL_IMAGE_CHANGE_NATIVE', data => {
      if (!data || !data.src) return;

      const skuImageIndex = this.state.mainImageList[
        PRODUCT_TAB_INDEX
      ].media.findIndex(m => {
        return (
          m.type === 'image' &&
          (m.imageUrl.thumb === data.src || m.imageUrl.big === data.src)
        );
      });

      if (skuImageIndex > -1) {
        this.setState({
          mainMediaIndex: skuImageIndex,
        });
      }
    });
    // window.addEventListener('ON_DETAIL_IMAGE_CHANGE_NATIVE', e => {
    //   debugger
    //   if (!e || !(e as CustomEvent).detail) return;
    //   const skuImageIndex = this.state.mainImageList[
    //     PRODUCT_TAB_INDEX
    //   ].media.findIndex(m => {
    //     return (
    //       m.type === 'image' &&
    //       (m.imageUrl.thumb === (e as CustomEvent).detail.src ||
    //         m.imageUrl.big === (e as CustomEvent).detail.src)
    //     );
    //   });
    //   this.setState({
    //     ...this.state,
    //     mainMediaIndex:
    //       skuImageIndex === -1 ? this.state.mainMediaIndex : skuImageIndex,
    //   });
    // });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
    this.sendStayTime();
  };

  setStayTimer = () => {
    dialogOpenTime = new Date().getTime();
  };

  sendStayTime = () => {
    if (!dialogOpenTime) return;
    const now = new Date().getTime();
    const time = (now - dialogOpenTime) / 1000;
    dialogOpenTime = null;
    safeLog(
      '/sc.details.commonLogs',
      'CLK',
      `info=time=${time}&action=mainImageDialogStay`,
    );
  };

  /**
   * 主图点击处理
   *
   * @memberof MainImage
   */
  onMainImageItemClick = index => () => {
    this.setState(
      {
        visible: true,
        mainMediaIndex: index,
        dialogTabIndex: 0,
      },
      () => {
        // 等dialog渲染好，等slider计算好位置之后才重设状态
        setTimeout(() => {
          const { mediaItemsOfState } = this.state;
          this.dialogEle = document.querySelector('.main-image-dialog');
          this.setState({
            ...this.state,
            dialogMediaIndex: this.state.tabs[
              PRODUCT_TAB_INDEX
            ].media.findIndex(item => item === mediaItemsOfState[index]),
            dialogHeight: `${
              this.dialogEle ? this.dialogEle.clientHeight - 140 : 400
            }`,
            // dialogWidth: `${this.dialogEle ? this.dialogEle.clientWidth : 400}`
          });
        }, 1000);
        safeLog(
          '/sc.details.commonLogs',
          'CLK',
          `info=${this.state.mediaItemsOfState[index].type}&action=openMainImageDialog`,
          'GET',
        );
        safeLog(
          '/sc.details.commonLogs',
          'CLK',
          `info=0&action=mainImageDialogTabClick`,
        );
        this.setStayTimer();
      },
    );
  };

  /**
   * 弹窗内缩略图点击处理
   *
   * @memberof MainImage
   */
  onDialogThumbItemClick = (tabIndex: number, itemIndex: number) => () => {
    this.setState({
      ...this.state,
      dialogTabIndex: tabIndex,
      dialogMediaIndex: itemIndex,
    });
    safeLog(
      '/sc.details.commonLogs',
      'CLK',
      `info=&action=mainImageDialogThumbClick`,
    );
  };

  /**
   * 主图下面缩略图点击处理
   *
   * @memberof MainImage
   */
  onMainImageThumbItemClick = (index: number) => () => {
    this.setState({
      mainMediaIndex: index,
    });
    const type = this.state.mainImageList[PRODUCT_TAB_INDEX].media[
      this.state.mainMediaIndex
    ].type;
    safeLog(
      '/sc.details.commonLogs',
      'CLK',
      `info=${type}&action=mainImageThumbClick`,
    );
  };

  /**
   * 弹窗内tab点击处理
   *
   * @memberof MainImage
   */
  onTabClick = (index: number) => () => {
    safeLog(
      '/sc.details.commonLogs',
      'CLK',
      `info=${index}&action=mainImageDialogTabClick`,
    );
    this.setState({
      ...this.state,
      dialogTabIndex: index,
      dialogMediaIndex: 0,
    });
  };

  /**
   * 弹窗内大图通过点击左右改变时
   *
   * @memberof MainImage
   */
  onDialogItemChange = (tabIndex: number) => (itemIndex: number) => {
    this.setState({
      ...this.state,
      dialogTabIndex: tabIndex,
      dialogMediaIndex: itemIndex,
    });
  };

  /**
   * 过滤只在弹窗中出现的内容
   *
   * @memberof MainImage
   */
  dialogMediaFilter = (mediaItems: PcMainImage.MediaItems) => {
    return mediaItems.filter(
      item => item.type === 'image' || item.type === 'video',
    );
  };

  /**
   * 弹窗中的媒体，按照业务类型聚类
   *
   * @memberof MainImage
   */
  generateTabs = (mediaItems: PcMainImage.MediaItems) => {
    const tabs: PcMainImage.MediaItemsInDialogTab = [];
    const mark = {};
    mediaItems.forEach((item:any) => {
      item.imageUrl = item.certImageUrlList ? item.certImageUrlList[0] : item.imageUrl;
      
      if (mark[item.bizType] === undefined) {
        tabs.push({
          tabName: item.bizType,
          media: [],
        });
        mark[item.bizType] = tabs.length - 1;
      }
      tabs[mark[item.bizType]] && tabs[mark[item.bizType]].media.push(item);
    });
    return tabs;
  };

  csClick = () => {
    const $startOrder = document.querySelector('#J-action-cs') as HTMLElement;
    if (!$startOrder) return;
    $startOrder.click();
  };

  doExpose() {
    const { productId } = this.props;

    if (!window._boothImageReadyWithFlasher && !window._boothImageReady) {
      safeLog(
        '/sc.details.boothImageReadyNull',
        'EXP',
        `detailId=${productId}`,
        'GET',
      );
    }
    const boothImageReady =
      window._boothImageReadyWithFlasher ||
      window._boothImageReady ||
      new Date().getTime();
    window.__BB = window.__BB || {};
    window.__BB.exposed = new Date(boothImageReady);
    window.__BB.group = window._boothImageReadyWithFlasher && 'flasher';
    window.__BB.extendParams = Object.assign({}, window.__BB.extendParams, {
      exposeType: 0,
      fetchComplete: window._fetchComplete || null,
    });
  }

  render() {
    const { i18n } = this.props;
    const { isEmpty } = this.state;

    const i18nMap = {
      custmizeBtn: getText(i18n, 'detailModule.custom.btn', 'Customise Now'),
      custmizeTxt: getText(
        i18n,
        'mainImage.custmizeTxt',
        'Click to customize online',
      ),
      larger: getText(i18n, 'mainImage.larger', 'View larger image'),
      exp: getText(i18n, 'mainImage.exp', 'Click here to expend view'),
      vrTxt: getText(i18n, 'mainImage.vrTxt', 'Click to enter 360 degree view'),
      vrBtn: getText(i18n, 'mainImage.vrBtn', 'Enter 360 Degree View'),
      cs: getText(i18n, 'rightAction.cs', 'Contact Supplier'),
    };

    const cs = (
      <div className="tab-ext-btn">
        <Button
          type="primary"
          onClick={this.csClick}
          style={{
            fontSize: 14,
          }}
        >
          {i18nMap.cs}
        </Button>
      </div>
    );

    return (
      <div className="pc-main-image-wrapper">
        {/* todo */}

        {isEmpty ? (
          <Empty />
        ) : (
          <div className="pc-main-image">
            <div
              id="detail-favorite-mark"
              data-fav-id={this.props.productId}
              data-type="product"
              data-hasbkgcircle="true"
            />
            {this.state.mainImageList.length > 0 ? (
              <Slider
                slickGoTo={this.state.mainMediaIndex}
                dataSource={this.state.mainImageList[PRODUCT_TAB_INDEX].media}
              >
                {this.state.mainImageList[PRODUCT_TAB_INDEX].media.map(
                  (mediaItem, index) => {
                    const MediaComponent = getMediaComponent(mediaItem.type);
                    return (
                      <Inner className="custom-inner" key={index}>
                        {/* props额外传递onItemClick, 在点击时使用。图片的hover自己内部处理 */}
                        <MediaComponent
                          {...mediaItem}
                          productId={this.props.productId}
                          onItemClick={this.onMainImageItemClick(index)}
                          className="main-image"
                          zoom
                        />
                      </Inner>
                    );
                  },
                )}
              </Slider>
            ) : null}
            <div className="operation-tip">
              {this.state.mainImageList[PRODUCT_TAB_INDEX] &&
                this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                  this.state.mainMediaIndex
                ].type === 'image' && (
                  <span
                    onClick={this.onMainImageItemClick(
                      this.state.mainMediaIndex,
                    )}
                  >
                    <span className="icon-magnifier" />
                    {i18nMap.larger}
                  </span>
                )}
              {this.state.mainImageList[PRODUCT_TAB_INDEX] &&
                this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                  this.state.mainMediaIndex
                ].type === 'video' && (
                  <span
                    onClick={this.onMainImageItemClick(
                      this.state.mainMediaIndex,
                    )}
                  >
                    <span className="icon-magnifier" />
                    {i18nMap.exp}
                  </span>
                )}
              {this.state.mainImageList[PRODUCT_TAB_INDEX] &&
                this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                  this.state.mainMediaIndex
                ].type === 'customHome' && (
                  <a
                    href={
                      (this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                        this.state.mainMediaIndex
                      ] as PcMainImage.CustomHomeData).customHome.url
                    }
                    target="_blank"
                    className="vr-btn-container"
                    onClick={() =>
                      safeLog(
                        '/sc.details.commonLogs',
                        'CLK',
                        `info=${
                          this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                            this.state.mainMediaIndex
                          ].type
                        }&action=openMainImageDialog`,
                        'GET',
                      )
                    }
                  >
                    <Button className="float-op-btn" type="normal">
                      {i18nMap.vrBtn}
                    </Button>
                    <span>{i18nMap.vrTxt}</span>
                  </a>
                )}
              {this.state.mainImageList[PRODUCT_TAB_INDEX] &&
                this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                  this.state.mainMediaIndex
                ].type === 'customModel' && (
                  <div
                    className="vr-btn-container"
                    onClick={() => {
                      const el = document.querySelector(
                        '.customise-entry',
                      ) as HTMLElement;
                      el && el.click();
                      safeLog(
                        '/sc.details.commonLogs',
                        'CLK',
                        `info=${
                          this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                            this.state.mainMediaIndex
                          ].type
                        }&position=link&action=openMainImageDialog`,
                        'GET',
                      );
                    }}
                  >
                    <Button className="float-op-btn" type="normal">
                      {i18nMap.custmizeBtn}
                    </Button>
                    <span>{i18nMap.custmizeTxt}</span>
                  </div>
                )}
              {this.state.mainImageList[PRODUCT_TAB_INDEX] &&
                this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                  this.state.mainMediaIndex
                ].type === 'lightCustomModel' && (
                  <div
                    className="vr-btn-container"
                    onClick={() => {
                      const el = document.querySelector(
                        '.customise-entry',
                      ) as HTMLElement;
                      el && el.click();
                      safeLog(
                        '/sc.details.commonLogs',
                        'CLK',
                        `info=${
                          this.state.mainImageList[PRODUCT_TAB_INDEX].media[
                            this.state.mainMediaIndex
                          ].type
                        }&position=link&action=openMainImageDialog`,
                        'GET',
                      );
                    }}
                  >
                    <Button className="float-op-btn" type="normal">
                      {i18nMap.custmizeBtn}
                    </Button>
                    <span>{i18nMap.custmizeTxt}</span>
                  </div>
                )}
            </div>
            <ul className="main-image-thumb-ul">
              {this.state.mainImageList.length > 0
                ? this.state.mainImageList[PRODUCT_TAB_INDEX].media
                    .slice(0, 7)
                    .map((mediaItem, index) => {
                      const MediaComponent = getMediaComponent(mediaItem.type);
                      const mainImageThumbCls = classnames(
                        'main-image-thumb-item',
                        {
                          active: index === this.state.mainMediaIndex,
                        },
                      );
                      return (
                        <li key={index} className={mainImageThumbCls}>
                          {/* props额外传递onItemClick, 在点击时使用。图片的hover自己内部处理 */}
                          <MediaComponent
                            {...mediaItem}
                            imageSize="thumb"
                            onItemClick={this.onMainImageThumbItemClick(index)}
                            thumb
                            thumbWidth={50}
                            thumbHeight={50}
                          />
                        </li>
                      );
                    })
                : null}
            </ul>
            <Dialog
              animation={false}
              visible={this.state.visible}
              onOk={this.onClose}
              isFullScreen
              closeMode="close"
              onCancel={this.onClose}
              onClose={this.onClose}
              footer={false}
              className="main-image-dialog"
            >
              <div>
                {/* Tab按照bizType类型进行聚类展示 */}
                <Tab extra={cs} className="main-image-tab" activeKey={this.state.tabs[this.state.dialogTabIndex || 0].tabName}>
                  {this.state.tabs.map((item, tabIndex) => {
                    return (
                      <TabPane
                        key={item.tabName}
                        title={`${item.tabName} (${item.media.length})`}
                        onClick={this.onTabClick(tabIndex)}
                      >
                        <div className="left-and-right-split">
                          <div
                            className="left-show"
                            style={{ height: this.state.dialogHeight }}
                          >
                            <Slider
                              slickGoTo={this.state.dialogMediaIndex}
                              dataSource={item.media}
                              onChange={this.onDialogItemChange(tabIndex)}
                              showArrow
                              containerHeight={this.state.dialogHeight}
                              enableScale
                            >
                              {item.media.map((i, index) => {
                                const MediaComponent = getMediaComponent(
                                  i.type,
                                );
                                return (
                                  <MediaComponent
                                    {...i}
                                    key={index}
                                    className="left-show-item"
                                    videoHeight={this.state.dialogHeight}
                                    videoWidth={this.state.dialogHeight}
                                    imageHeight={this.state.dialogHeight}
                                    imageSize="big"
                                  />
                                );
                              })}
                            </Slider>
                          </div>
                          <ul
                            className="right-list"
                            style={{ height: this.state.dialogHeight }}
                          >
                            {item.media.map((i, itemIndex) => {
                              const MediaComponent = getMediaComponent(i.type);
                              const dialogThumbItemCls = classnames(
                                'right-list-item',
                                {
                                  active:
                                    itemIndex === this.state.dialogMediaIndex,
                                },
                              );
                              return (
                                <li
                                  className={dialogThumbItemCls}
                                  key={itemIndex}
                                >
                                  <MediaComponent
                                    {...i}
                                    className="right-list-item-item"
                                    imageSize="thumb"
                                    onItemClick={this.onDialogThumbItemClick(
                                      tabIndex,
                                      itemIndex,
                                    )}
                                    thumb
                                    isCurrent={
                                      itemIndex === this.state.dialogMediaIndex
                                    }
                                    thumbWidth={72}
                                    thumbHeight={72}
                                  />
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </TabPane>
                    );
                  })}
                </Tab>
              </div>
            </Dialog>
          </div>
        )}

        <div>
          <AsyncCompareAndShare
            {...this.props}
            style={{
              marginTop: 8,
            }}
          />
        </div>
      </div>
    );
  }
}

window._renderMainImageRendered = window._renderMainImageRendered || false;
